export const msg = 'module a'
